import * as Sentry from '@sentry/react';

import { getEnvironment } from '../utils';

import { alarm as makeAlarm } from './alarm.js';
import { filterEvent } from './sentry-event-filters/index.js';

const {
  ERROR_REPORTING_VIA_CONSOLE = 'false',
  WB_ENV,
  SENTRY_DSN,
} = getEnvironment();

// Sentry should not be used in tests, and breaks them anyway
const consoleLogger = [
  'debug',
  'info',
  'warning',
  'error',
  'fatal',
  'message',
  'alarm',
].reduce(
  (acc, level) =>
    Object.assign(acc, {
      // eslint-disable-next-line no-console
      [level]: (console[level] || console.log).bind(console),
    }),
  {}
);

Sentry.init({
  dsn: SENTRY_DSN,
  environment: WB_ENV,
  enableAutoSessionTracking: true,
  sessionTrackingIntervalMillis: 60000,
  normalizeDepth: 10,
  ignoreUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/fbevents\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
  ],
  beforeSend(event, hint) {
    return filterEvent(event, hint);
  },
});

const mergeContext = (level, context) => ({
  level,
  extra: context,
});
const sendSentryEvent =
  (level = 'info') =>
  (error, context) => {
    const standardError = error instanceof Error ? error : new Error(error);

    Sentry.captureException(standardError, mergeContext(level, context));
  };

const exceptionLogger = {
  debug: sendSentryEvent('debug'),
  info: sendSentryEvent('info'),
  warning: sendSentryEvent('warning'),
  error: sendSentryEvent('error'),
  fatal: sendSentryEvent('fatal'),
  alarm: makeAlarm(sendSentryEvent('error')),
  message: Sentry.captureMessage,
};

export const logger =
  ERROR_REPORTING_VIA_CONSOLE == 'true' ? consoleLogger : exceptionLogger;

export const identifyLoggedUser = (userId) =>
  Sentry.configureScope((scope) => {
    scope.setUser({
      id: userId,
    });
  });

export const clearLoggedUser = () =>
  Sentry.configureScope((scope) => scope.setUser(null));
